import React from 'react';
import LloydMatImage from "./LloydMatImage";
import LloydMatCaption from "./LloydMatCaption";
import clsx from "clsx";
import CatchErrors from "../../../Utility/CatchErrors";

// LloydMatChooserItem - one per available item, inside LloydMatChooser
export default function LloydMatChooserItem({lloydItem, callbacks, cartItem}) {

  function handleSelect(evt) {
    let pn = lloydItem.extendedPartNumber;

    callbacks.selectItem(pn);
  }

  const className = clsx(
    'inner text-center group bg-white h-full pt-4 px-8 pb-8 relative cursor-pointer border',
    cartItem ? 'border-brand-orange' : 'border-gray-300',
    'hover:border-brand-orange'
  );

  // part number note - some have embedded HTML, alas
  // it's directly under the image instead of in the absolute LloydMatCaption,
  // because that's absolute and therefore needs a fixed height
  const note = lloydItem.partNumberNote?.replaceAll("|", ' - ');

  return (
    <CatchErrors>
      <div className={className}>
        <a className="block h-full text-gray-600" onClick={handleSelect}>
          <LloydMatImage lloydItem={lloydItem}/>

          {note && <p className="text-sm text-gray-600 mt-2 leading-none">
            <strong>Note:</strong>{' '}
            <em dangerouslySetInnerHTML={{__html: note}}/>
          </p>}

          <LloydMatCaption lloydItem={lloydItem} cartItem={cartItem}/>
        </a>
      </div>
    </CatchErrors>);
}
